import { useTranslation } from 'react-i18next';
import { Rocket, Sparkles, Clock } from 'lucide-react';

const Changelog = () => {
  const { t } = useTranslation();

  return (
    <section id="changelog" className="py-20 px-4 sm:px-6 lg:px-8 bg-white dark:bg-slate-900">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            {t('changelog.title')}
          </h2>
          <p className="text-xl text-slate-600 dark:text-slate-400">
            {t('changelog.subtitle')}
          </p>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-px bg-slate-200 dark:bg-slate-700" />

          <div className="space-y-10">
            {/* Released entries */}
            <div className="relative pl-16">
              <div className="absolute left-0 flex items-center justify-center w-12 h-12 rounded-full bg-sky-100 dark:bg-sky-900 ring-4 ring-white dark:ring-slate-900">
                <Rocket className="w-5 h-5 text-sky-600 dark:text-sky-400" />
              </div>
              <div className="bg-slate-50 dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
                <span className="inline-block mb-2 text-xs font-semibold uppercase tracking-wider text-sky-600 dark:text-sky-400 bg-sky-50 dark:bg-sky-900/40 px-2.5 py-1 rounded-full">
                  {t('changelog.released')}
                </span>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
                  {t('changelog.v1.title')}
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-slate-700 dark:text-slate-300">
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-sky-500 flex-shrink-0" />
                    {t('changelog.v1.launch')}
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative pl-16">
              <div className="absolute left-0 flex items-center justify-center w-12 h-12 rounded-full bg-emerald-100 dark:bg-emerald-900 ring-4 ring-white dark:ring-slate-900">
                <Sparkles className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
              </div>
              <div className="bg-slate-50 dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
                <span className="inline-block mb-2 text-xs font-semibold uppercase tracking-wider text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/40 px-2.5 py-1 rounded-full">
                  {t('changelog.released')}
                </span>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
                  {t('changelog.v1_1.title')}
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-slate-700 dark:text-slate-300">
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-emerald-500 flex-shrink-0" />
                    {t('changelog.v1_1.calendarMarkers')}
                  </li>
                </ul>
              </div>
            </div>

            {/* Coming Soon */}
            <div className="relative pl-16">
              <div className="absolute left-0 flex items-center justify-center w-12 h-12 rounded-full bg-violet-100 dark:bg-violet-900 ring-4 ring-white dark:ring-slate-900">
                <Clock className="w-5 h-5 text-violet-600 dark:text-violet-400" />
              </div>
              <div className="bg-slate-50 dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
                <span className="inline-block mb-2 text-xs font-semibold uppercase tracking-wider text-violet-600 dark:text-violet-400 bg-violet-50 dark:bg-violet-900/40 px-2.5 py-1 rounded-full">
                  {t('changelog.comingSoon')}
                </span>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
                  {t('changelog.upcoming.title')}
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-slate-700 dark:text-slate-300">
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-violet-500 flex-shrink-0" />
                    {t('changelog.upcoming.dayTracker')}
                  </li>
                  <li className="flex items-start gap-2 text-slate-700 dark:text-slate-300">
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-violet-500 flex-shrink-0" />
                    {t('changelog.upcoming.colorPicker')}
                  </li>
                  <li className="flex items-start gap-2 text-slate-700 dark:text-slate-300">
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-violet-500 flex-shrink-0" />
                    {t('changelog.upcoming.manyMore')}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Changelog;
